import React from "react";
import ToTop from "./ToTop";

export default function Footer() {
  return (
    <>
      <footer className="site-footer-main">
        Copyright &copy; {new Date().getFullYear()}{" "}
        {process.env.REACT_APP_API_SITE_TITLE}. All Rights Reserved.
      </footer>
      <ToTop />
    </>
  );
}
